import React, { Component } from 'react';
import { Card, CardHeader, CardText } from 'material-ui';
import PropTypes from 'prop-types';
import injectSheet from 'react-jss';

import FilterButton from './filterButton';
import Loading from './loading';
import ErrorState from './error';

import HelpOutline from 'material-ui/svg-icons/action/help-outline';

import * as charts from './charts';

const { any, array, bool, node, object, oneOf, string, func, number } = PropTypes;

const defaultStyles = {
  container: props => {
    const grid = props.grid || [1, 1];
    const gutter = props.gutter || 12;
    return {
      width: `${grid[0] * 270 + gutter * (grid[0] - 1)}px`,
      height: `${grid[1] * 100 + gutter * (grid[1] - 1)}px`,
    };
  },
  title: {
    fontSize: '16px',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '0',
    alignItems: 'center',
  },
  widgetContent: props => {
    if (props.title) {
      return {
        height: 'calc(100% - 55px)',
        overflowY: 'auto',
        marginTop: '-8px',
      };
    }
    return {
      overflowY: 'auto',
      marginTop: '8px',
    };
  },
};

const styles = Object.assign({}, defaultStyles, styles);

class DashboardWidget extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isFilterOpen: false,
    };
  }

  onFilterChange = filterBy => (i, item) => {
    this.handleFilterMenu();
    this.props.updateFilter(this.props.widgetId, filterBy, {
      filterLabel: item.label,
      filterValue: item.value,
    });
  };

  getHelpText = text => {
    return (
      <span className="hint--bottom hint--large hint--rounded" aria-label={text}>
        <HelpOutline style={{ width: '12px', height: '12px', color: 'rgb(117, 117, 117)' }} />
      </span>
    );
  };

  handleFilterMenu = () => {
    this.setState({ isFilterOpen: !this.state.isFilterOpen });
  };

  render() {
    const {
      children,
      classes,
      containerStyle,
      data,
      error,
      filters,
      grid,
      headerStyle,
      helpText,
      innerStyle,
      isLoading,
      title,
      titleStyle,
      type,
    } = this.props;
    if (error) {
      return (
        <Card
          className={classes.container}
          style={containerStyle}
          containerStyle={{ height: '100%' }}
        >
          <ErrorState grid={grid} />
        </Card>
      );
    }
    if (isLoading) {
      return (
        <Card
          className={classes.container}
          style={containerStyle}
          containerStyle={{ height: '100%' }}
        >
          <Loading grid={grid} />
        </Card>
      );
    }

    const Chart = charts[type];
    return (
      <Card
        className={classes.container}
        style={containerStyle}
        containerStyle={{ height: '100%' }}
      >
        {Boolean(title) && (
          <CardHeader
            className={classes.title}
            title={
              <span>
                {title}
                {helpText && (
                  <span style={{ padding: '0 0 0 5px' }}>{this.getHelpText(helpText)}</span>
                )}
              </span>
            }
            titleStyle={Object.assign({}, defaultStyles.title, titleStyle)}
            style={Object.assign({}, headerStyle)}
            textStyle={{ padding: 0 }}
          >
            <div>
              {filters &&
                Object.values(filters).map(({ filterItems, filterLabel, filterBy }, i) => (
                  <FilterButton
                    key={i}
                    items={filterItems}
                    filterLabel={filterLabel}
                    style={{ display: 'inline-block', marginLeft: '4px' }}
                    onButtonClick={this.handleFilterMenu}
                    onFilterChange={this.onFilterChange(filterBy)}
                  />
                ))}
            </div>
          </CardHeader>
        )}
        <CardText
          className={classes.widgetContent}
          style={Object.assign({}, DashboardWidget.defaultProps.innerStyle, innerStyle)}
        >
          {!type ? children : <Chart data={data} />}
        </CardText>
      </Card>
    );
  }
}

DashboardWidget.defaultProps = {
  innerStyle: { padding: '0 11px' },
};

DashboardWidget.propTypes = {
  children: node,
  classes: object,
  containerStyle: object,
  data: any,
  error: any,
  filters: object,
  grid: array,
  headerStyle: object,
  helpText: string,
  innerStyle: object,
  isLoading: bool,
  title: string,
  titleStyle: object,
  updateFilter: func,
  widgetId: number,
  type: oneOf([
    'ContractActivityFeed',
    'ContractFunnel',
    'SentItems',
    'ContractActivityStats',
    'ContractTaskList',
    'PotentialPartners',
  ]),
};

export default injectSheet(styles)(DashboardWidget);



// WEBPACK FOOTER //
// ./src/app/components/contracting-dashboard/components/dashboardWidget.jsx